<template>
   <a class="mail-link" :href="mailTarget">Send by email</a>
</template>

<script>
export default {
  name: 'MailLink',
  data: vm => ({
    mailTarget: ''
  }),
  href: '#',
  methods: {
    setTarget (email, subject, body) {
      this.mailTarget = 'mailto:' + email + '?' +
        'subject=' + subject + '&' +
        'body=' + body
    }
  }
}
</script>
